function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import { xprod, flatten, compose } from 'ramda';
import { Debug } from './debug';
var debug =
/*#__PURE__*/
Debug('@foxford/ui/helpers');
/**
 * Recieves camelcase string returns array of lower case words
 *
 * @param {string} str
 *
 * @returns {array} array of lower case words
 */

export var camelCaseToArray = function camelCaseToArray() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (str.slice(0, 1).toLowerCase() + str.slice(1)).replace(/([A-Z]+)/g, ' $1').toLowerCase().split(' ');
};
/**
 * Recieves array of lower or camel case words returns array camel case string
 *
 * @param {array} array of lower or camel case words
 *
 * @returns {string} camel case string
 */

export var arrayToCamelCase = function arrayToCamelCase() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return !array.length ? '' : array.reduce(function (acc) {
    var part = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var index = arguments.length > 2 ? arguments[2] : undefined;
    return "".concat(acc).concat(index ? "".concat(part[0].toUpperCase()).concat(part.slice(1)) : part.toLowerCase());
  }, '');
};
/**
 * Recieves array of parts, property variations consist of and possible values,
 * returns prop types object
 *
 * @param partsPropsArr {array} of parts, property variations consist of
 * @param values {array} possible values
 *
 * @returns {object} propTypes
 *
 * Usage:
 *
 * static propTypes = {
      className: string,
      ...makeComplexAttributePropType([
        Object.keys(PadMarg.padMargProp),
        // eslint-disable-line array-element-newline
        Object.keys(PadMarg.side),
        // eslint-disable-line array-element-newline
        Object.keys(PadMarg.breakpoint),
      ], [...Object.keys(PadMarg.size), false]),
    }

  Output:

  { "padding": PropTypes.oneOf[...],
    "paddingTop": PropTypes.oneOf[...],
    "paddingRight": PropTypes.oneOf[...],
    "paddingBottom": PropTypes.oneOf[...],
    "paddingLeft": PropTypes.oneOf[...],
    "paddingL": PropTypes.oneOf[...],
    "paddingM": PropTypes.oneOf[...],
    "paddingS": PropTypes.oneOf[...],
    "paddingXs": PropTypes.oneOf[...],
    "paddingTopL": PropTypes.oneOf[...],
    "paddingTopM": PropTypes.oneOf[...],
    "paddingTopS": PropTypes.oneOf[...],
    "paddingTopXs": PropTypes.oneOf[...],
    "paddingRightL": PropTypes.oneOf[...],
    "paddingRightM": PropTypes.oneOf[...],
    "paddingRightS": PropTypes.oneOf[...],
    "paddingRightXs": PropTypes.oneOf[...],
    "paddingBottomL": PropTypes.oneOf[...],
    "paddingBottomM": PropTypes.oneOf[...],
    "paddingBottomS": PropTypes.oneOf[...],
    "paddingBottomXs": PropTypes.oneOf[...],
    ..
  }
 */

export var makeComplexAttributePropType = function makeComplexAttributePropType() {
  var partsPropsArr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var getValue = arguments.length > 2 ? arguments[2] : undefined;
  var propTypes = {};
  var propTypeValue = typeof getValue === 'function' ? getValue(values) : PropTypes.oneOf(values);

  var combineParts = function combineParts(list) {
    return list.reduce(function (acc) {
      var partProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (!acc.length) {
        return partProps;
      }

      return xprod(acc, partProps);
    }, []);
  };

  var makePropTypes = function makePropTypes(it) {
    return it.reduce(function () {
      var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var prop = arguments.length > 1 ? arguments[1] : undefined;
      Object.assign(acc, _defineProperty({}, prop, propTypeValue));
      return acc;
    }, propTypes);
  };

  return compose(makePropTypes, function (_) {
    return _.map(arrayToCamelCase);
  }, function (_) {
    return _.map(flatten);
  }, combineParts)(partsPropsArr);
};
/**
 * Parse exportted SASS map string into JSON
 *
 * @param mapStr {string} - SASS map
 * @returns object {object} - parsed json
 */

export function parseSassMap(mapStr) {
  if (!mapStr) throw new Error('Got empty string on parsing SASS map');

  if (mapStr.slice(0, 1) === '(') {
    mapStr = mapStr.slice(1, mapStr.length - 1); // eslint-disable-line no-param-reassign
  }

  var chunks = mapStr.split(/[,:]/);
  var splittedMap = chunks.reduce(function (acc, it, i) {
    var prepareKey = function prepareKey(_) {
      return _.replace(/['"]/ig, '').trim();
    };

    if (!i % 2) {
      var key = prepareKey(it);

      if (key.match(/[()]/g)) {
        debug('Got the key:', key);
        throw new Error('Can not transform SASS map to Object');
      }

      acc[key] = undefined;
    }

    if (i % 2) acc[prepareKey(chunks[i - 1])] = it.trim();
    return acc;
  }, {});
  return splittedMap;
}
/**
 * Parse exportted SASS map string into JSON
 *
 * @param obj {object} - key: param's name, value - it's value
 * @returns object {object} - where key: param's name, value: param entrie
 */

export function makeParamsObj() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paramsObj = {};
  Object.entries(obj).map(function (entrie) {
    paramsObj[entrie[0]] = entrie;
    return entrie;
  });
  return paramsObj;
}
export function makeParamsObjFromSassMap() {
  var mapStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return makeParamsObj(parseSassMap(mapStr));
}